export function buildGestoresEquipeReturnQuery(input: { search: string; view?: 'lista' | 'calendario' }) {
  const params = new URLSearchParams()
  params.set('tab', 'equipe')
  if (input.search.trim()) params.set('eqSearch', input.search.trim())
  if (input.view === 'calendario') params.set('eqView', 'calendario')
  return params.toString()
}

export function parseGestoresEquipeView(value: string | null): 'lista' | 'calendario' {
  return value === 'calendario' ? 'calendario' : 'lista'
}
